<template>
  <div>
    <van-skeleton title animate :row="12" round="true" :loading="loading_ske">
      <div class="titles">
        公司审核列表
      </div>
      <Table border ref="selection" :columns="columns7" :data="data6" :loading="loading"></Table>
      <div class="role02">
        <Page :total="total" @on-change="nextPage"/>
      </div>
    </van-skeleton>
  </div>
</template>

<script>
  import httpCom from '@/api/Com';
  import util from "../../util/util";
  export default {
    name: "auditCom",
    data() {
      return {
        columns7: [
          {
            title: '公司名称',
            key: 'name',
            render: (h, params) => {
              return h('div', [
                h('Icon', {
                  props: {
                    type: 'person'
                  }
                }),
                h('strong', params.row.name)
              ]);
            }
          },
          {
            title: '管理员',
            key: 'userName'
          },
          {
            title: '审核状态',
            key: 'shStatus'
          },
          {
            title: '操作',
            key: 'action',
            width: 200,
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'info',
                    size: 'small',
                    icon:'md-checkmark-circle-outline'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.edit(params.index)
                    }
                  }
                }, '同意'),
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small',
                    icon:'md-close-circle'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.delCom(params.index)
                    }
                  }
                }, '拒绝'),
              ]);
            }
          }
        ],
        data6: [],
        loading_ske:true,     //骨架屏显示
        page:1,               //页数
        pageSize:10,          //显示条数
        total:0,              //列表总数
        loading:false,        //是否加载
      }
    },
    mounted() {
      var me = this;
      let user = JSON.parse(sessionStorage.getItem('user'));
      let data = {
        state:0,
        mobile:user.mobile,
        sign:user.sign,
        page:me.page,
        pageSize:me.pageSize,
        companyId:user.companyId
      }
      if (user.companyId == 1) {
        data.companyId = '';
      }
      httpCom.list(data).then(res => {
        me.data6 = res.data.dataList;
        me.data6.forEach(function (item,index) {
          me.$set(item,'shStatus','未审核');
        })
        me.total = res.data.totalNum;
        me.loading_ske = false;
      })
    },
    methods:{
      nextPage(e){//下一页
        var me = this;
        me.loading = true;
        let user = JSON.parse(sessionStorage.getItem('user'));
        let data = {
          state:0,
          mobile:user.mobile,
          sign:user.sign,
          page:e,
          pageSize:me.pageSize,
          companyId:user.companyId
        }
        if (user.companyId == 1) {
          data.companyId = '';
        }
        httpCom.list(data).then(res => {
          console.log(res);
          me.data6 = res.data.dataList;
          me.data6.forEach(function (item,index) {
            me.$set(item,'shStatus','未审核');
          })
          me.loading = false;
        })
      },
      delCom(index){//拒绝加入公司
        var me = this;
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth =  util.is_Auth(menu,'公司管理','拒绝公司申请');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        me.$confirm('此操作将拒绝同意该公司加入, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          me.$Loading.start();
          let user = JSON.parse(sessionStorage.getItem('user'));
          let data = {
            userId: user.userId,
            sign: user.sign,
            companyId: me.data6[index].id,
            mobile:user.mobile,
            state:2
          };
          httpCom.auditCom(data).then(res => {
            switch (res.code) {
              case '0000':
                me.data6.splice(index,1);
                me.$message.success('已拒绝申请');
                me.$Loading.finish();
                break;
              case '1111':
                me.$message.error('审核失败');
                me.$Loading.error();
                break;
            }
          })
        })
      },
      edit(index){//同意加入公司
        var me = this;
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth =  util.is_Auth(menu,'公司管理','通过公司申请');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        me.$confirm('此操作将同意该公司加入, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          me.$Loading.start();
          let user = JSON.parse(sessionStorage.getItem('user'));
          let data = {
            userId: user.userId,
            sign: user.sign,
            companyId: me.data6[index].id,
            mobile:user.mobile,
            state:1
          };
          httpCom.auditCom(data).then(res => {
            switch (res.code) {
              case '0000':
                me.data6.splice(index,1);
                me.$message.success('已同意申请');
                me.$Loading.finish();
                break;
              case '1111':
                me.$message.error('审核失败');
                me.$Loading.error();
                break;
            }
          })
        })
      }
    }
  }
</script>

<style scoped>
@import "company.css";
</style>